module.exports = __webpack_public_path__ + "media/images/see_detailview-c7ecab8c0ef328da0a0a4f259eacfef9.gif";